import styled from 'styled-components';

export const MeterDeviceResponseContainer = styled.div<{
  color: string;
  borderColor: string;
  isLoading?: boolean;
}>`
  background-color: ${({ color }) => color};
  border: 1px solid;
  border-color: ${({ borderColor }) => borderColor};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  flex: 1;

  margin-right: 4px;
`;

export const StyledDot = styled.div<{ color: string }>`
  width: 12px;
  height: 12px;
  border-radius: 12px;
  background-color: ${({ color }) => color};
  margin-right: 8px;
  margin-bottom: 2px;
`;

export const TimeStampContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const MeterDeviceLabel = styled.p<{ color?: string }>`
  color: ${({ color }) => color || '#7f7f7f'};
  margin-bottom: 0px;

  font-weight: 300;
  font-size: 15px;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Label = styled.div`
  color: #7f7f7f;
  margin-bottom: 2px;
  font-weight: 300;
  font-size: 14px;
`;
